const INITIAL_STATE = {
  customerList: [],
};

export default function customer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      // console.log('payload************', payload);
      if (payload && payload.key === 'customer') {
        return {
          ...state.customerList,
          ...payload.response.data,
        };
      } else if (payload && payload.key === 'onSearchCustomers') {
        return {
          customerList: [
            ...payload.response.data,
          ],
        }
      }
      else if (payload && payload.key === 'payers') {
        // console.log('customerList state....', state);
        const payers = [];
        state.business.payers.forEach(payer => {
          // console.log('payer result ', payer)
          // console.log(' payload.response ',  payload.response)
          if(payer.payer_sap_code === payload.response.data.payer_sap_code){

            const data = {
              ...payer,
              sap_digital_order_balance: payload.response.data.sap_digital_order_balance,
              orders_not_invoiced_price: payload.response.data.orders_not_invoiced_price

            }
            payers.push(data);
          }  else {
            // console.log('inside payer2');
            payers.push(payer);
          }
 
        });
        state.business.payers = payers

        return {
          ...state,
          // payers
        }
      }

      return state;
    }

    case 'clearCustomerList': {
      // console.log('INITIAL_STATE2', state);
        return INITIAL_STATE;
      }

    default:
      return state;
  }
}
